import React from 'react';
import ChallengeBanner from '@components/challenge/challengeBanner';
import ChallengeList from '@components/challenge/challengeList';
import { useMatchChallengeList } from '@repository/match';

import classnames from 'classnames/bind';
import styles from './challenge.module.scss';
const cx = classnames.bind(styles);

const EmptyPage = () => {
  return (
    <div className={cx('emptyArea')}>
      <strong className={cx('title')}>현재 등록된 채용이벤트가 없어요.</strong>
      <p className={cx('desc')}>
        채용 관련 이벤트가 생길 경우,
        <br />
        해당 페이지에서 확인하실 수 있어요.
      </p>
    </div>
  );
};

const Challenge = () => {
  const { data: challengeListData, isLoading } = useMatchChallengeList();

  if (!challengeListData || isLoading) return null;
  if (!challengeListData.challenges.length) return <EmptyPage />;

  return (
    <div className={cx('wrap')}>
      <ChallengeBanner />
      <ChallengeList challengeListData={challengeListData.challenges} />
    </div>
  );
};

export default Challenge;
